import { Label } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useFilterChangeCallback, useSelectorWithConfig } from 'shared/hooks';
import { selectEarlyAccessFilter } from 'shared/selectors/advancedFilters/earlyAccess';
import { CustomCheckbox } from 'shared/components/CustomCheckbox';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';

export const EarlyAccessContainer: FC = () => {
  const { label, value, description, visible } = useSelectorWithConfig(selectEarlyAccessFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, value: boolean) => {
      onChange({ action: 'setEarlyAccess', arguments: [value || null] });
    },
    [onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label="Новые объявления">
      <InlineFilter width={410}>
        <CustomCheckbox
          label={label}
          checked={value}
          onChange={handleChange}
          caption={description}
          rightAdornment={
            <Label background="accent-negative-primary" color="text-inverted-default">
              Новое
            </Label>
          }
        />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
